import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  subscriptions: {
    id: 'studio.J+dIsA',
    defaultMessage: 'Subscriptions',
  },
});
